var bindCheck = { check: '=' };
var YES_NO_ARR = [
    'Yes',
    'No',
    "Yes/No",
];
var NA_ARR = [
    'Yes',
    'No',
    'Not applicable'
];
var RESP_ARR = [
    "APPROVED", "NOT_APPROVED", "MANUAL_REVIEW"
];
var CODE_RESP = [
    'DBG_DUPLICATE',
    'EXISTING_REGISTRATION',
    'CLIP',
    'EXISTING_IBM_LED',
    'GOE',
    'CEIDS',
    'GLOBALCLIENT',
    'PROSPECT',
    'NO_SKILLS',
    'TA',
    'NOT_APPLICABLE',
    'NO_BPA_TA',
    'NOT_CHECKED',
    'NO_SOLUTIONS',
    'SYS_ERROR',
    'EXISTING_CLIENT',
    'DCID_DUPLICATE',
    'NOT_CHECKED',
    'JP_REVIEW',
];
var CMR_ARR = [
    "Standard",
    "Prospect",
    "Not Provided",
    "Standard/Prospect",
    "Standard/Not Provided",
    "Prospect/Not Provided",
    "Standard/Prospect/Not Provided"
];
var DR_GOE_ARR = [
    "Yes",
    "No",
    "Unknown",
    "State Owned",
    "Yes/No",
    "Yes/Unknown",
    "Yes/State Owned",
    "No/Unknown",
    "No/State Owned",
    "Unknown/State Owned",
    "Yes/No/Unknown",
    "Yes/No/State Owned",
    "Yes/Unknown/State Owned",
    "No/Unknown/State Owned",
    "Yes/No/Unknown/State Owned"
];
var MYSA_DUP = [
    "Yes",
    "No",
    "Manual Review",
    "Yes/No",
    "Yes/Manual Review",
    "No/Manual Review",
    "Yes/No/Manual Review"
];
var CD_ARR = [
    "BP-Led",
    "Co-Led",
    "IBM-Led",
    "Unassigned",
    "BP-Led/Co-Led",
    "BP-Led/IBM-Led",
    "Co-Led/IBM-Led",
    "BP-Led/Unassigned",
    "IBM-Led/Unassigned",
    "Co-Led/Unassigned",
    "BP-Led/Co-Led/IBM-Led",
    "BP-Led/Co-Led/Unassigned",
    "BP-Led/IBM-Led/Unassigned",
    "Co-Led/IBM-Led/Unassigned",
    "BP-Led/Co-Led/IBM-Led/Unassigned",
];
var TA_ARR = [
    "Yes",
    "No",
    "Not Applicable",
    "Manual Review",
    "Yes/No",
    "Yes/Not Applicable",
    "Yes/Manual Review",
    "No/Not Applicable",
    "No/Manual Review",
    "Yes/No/Not Applicable",
    "Yes/No/Manual Review",
    "No/Not Applicable/Manual Review",
    "Yes/No/Not Applicable/Manual Review"
];
var INCENTIVES_GOE_ARR = [
    "Yes",
    "No",
    "Unknown",
    "State Owned",
    "Manual Review",
    "Yes/No",
    "Yes/Unknown",
    "Yes/State Owned",
    "Yes/Manual Review",
    "No/Unknown",
    "No/State Owned",
    "No/Manual Review",
    "Unknown/State Owned",
    "Unknown/Manual Review",
    "State Owned/Manual Review",
    "Yes/No/Unknown",
    "Yes/No/State Owned",
    "Yes/No/Manual Review",
    "Yes/Unknown/State Owned",
    "Yes/Unknown/Manual Review",
    "Yes/State Owned/Manual Review",
    "No/Unknown/State Owned",
    "No/Unknown/Manual Review",
    "No/State Owned/Manual Review",
    "Unknown/State Owned/Manual Review",
    "Yes/No/Unknown/State Owned",
    "Yes/No/Unknown/Manual Review",
    "Yes/No/State Owned/Maunal Review",
    "No/Unknown/State Owned/Manual Review",
    "Yes/No/Unknown/State Owned/Manual Review",
];
var SC_DUP = [
    "Yes",
    "No",
    "Manual Review",
    "Yes/No",
    "Yes/Manual Review",
    "No/Manual Review",
    "Yes/No/Manual Review"
];
var NC = [
    "Yes",
    "No",
    "Manual Review",
    "Yes/No",
    "Yes/Manual Review",
    "No/Manual Review",
    "Yes/No/Manual Review"
];
var SOLUTION_ARR = [
    "Yes",
    "No",
    "Manual Review",
    "Yes/No",
    "No/Manual Review",
    "Yes/No/Manual Review"
];
var CD_RESP = [
    "BP_LED", "CO_LED", "IBM_LED", "MANUAL_REVIEW"
];
var SPEC_BID_RESP = [
    "APPROVED", "NOT_APPROVED", "MANUAL_REVIEW", "NOT_APPLICABLE"
];
var CVR_SSA_RESP = [
    "BP_ID", "IBM_ID", "NOT_APPROVED", "MANUAL_REVIEW"
];
var RESP_INC_GOE_ARR = [
    "APPROVED", "NOT_APPROVED", "MANUAL_REVIEW", "GOVERNMENT_OWNED", "STATE_OWNED", "NO"
];
var DEFAULT_SELECTION = '-Please select-';
var CheckResultsUpdateController = (function () {
    function CheckResultsUpdateController(settings, env, $compile, $filter, socket, $scope, Dialog, notify, DTOptionsBuilder, DTColumnBuilder) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.notify = notify;
        this.DTOptionsBuilder = DTOptionsBuilder;
        this.DTColumnBuilder = DTColumnBuilder;
        this.TEMPLATE_CONFIRM = 'confirm-prompt.html';
        this.checkData = this.check;
        this.tableItems = [];
        this.backendModuleName = 'admin/mysaresponse/mysa-response';
        this.scopePrefix = 'admin.mysaresponse';
        this.scopeDeleteRecord = this.scopePrefix + ".delete";
        this.scopeUpdateRecord = this.scopePrefix + ".update";
        this.scopeCreateRecord = this.scopePrefix + ".insert";
        this.table = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: {},
            search: '',
            select_options: {},
            visible: 0
        };
        this.tableLog = {
            dtColumns: {},
            dtInstance: {},
            filter: false,
            filterParams: {},
            filters: {},
            search: '',
            select_options: {},
            visible: 0
        };
        // CREATE
        this.socket.forward(this.scopeCreateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeCreateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create a record');
                _this.notify.error("Unable to create a record");
            }
            else {
                _this.notify.success('Record successfuly added');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // DELETE
        this.socket.forward(this.scopeDeleteRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeDeleteRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Delete record');
                _this.notify.error("Unable to delete record");
            }
            else {
                _this.notify.success('Record was deleted successful!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
        // UPDATE
        this.socket.forward(this.scopeUpdateRecord, this.$scope);
        this.$scope.$on("socket:" + this.scopeUpdateRecord, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Update the record');
                _this.notify.error("Unable to update the record");
            }
            else {
                _this.notify.success('Comliance plan successfuly updated!');
                _this.tableLog.dtInstance.DataTable.ajax.reload(null, true);
            }
            _this.table.dtInstance.DataTable.ajax.reload(null, true);
        });
    }
    CheckResultsUpdateController.prototype.$onInit = function () {
        var _this = this;
        this.signalWrongResponse = '';
        this.columnIdName = this.checkData.columnIdName;
        this.columnLogIdName = this.checkData.columnLogIdName;
        this.table.dtColumns = this.buildColumns(this.columnIdName);
        this.table.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('ajax', this.buildAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
        this.tableLog.dtColumns = this.buildColumns(this.columnLogIdName);
        this.tableLog.dtOptions = this.DTOptionsBuilder.newOptions()
            .withIBMTheme()
            .withOption('ajax', this.buildLogAjaxOption())
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('searchDelay', 1000)
            .withOption('order', [[0, 'desc']]) // Default sorting by time
            .withPaginationType('full_numbers')
            .withOption('createdRow', function (row) {
            _this.$compile(angular.element(row).contents())(_this.$scope);
        })
            .withOption('drawCallback', function (settings) {
            _this.processing = false;
        });
    };
    /**
       * Function to delete a row in DB
    */
    CheckResultsUpdateController.prototype.deleteRow = function (event, rowId) {
        var _this = this;
        var rowData = this.tableItems[rowId];
        var dataToDelete = {
            ID: rowData['ID']
        };
        this.Dialog.confirmDelete(event, rowData).then(function (dResult) {
            if (dResult) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: dataToDelete,
                        table: _this.checkData.db,
                        email: _this.env.user.email,
                        function: 'deleteRecord',
                        scopeBack: _this.scopeDeleteRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            }
        });
    };
    /**
       * Function to insert a row in DB
    */
    CheckResultsUpdateController.prototype.addRow = function (event) {
        var _this = this;
        var result = this.extractCountry();
        var tit = 'Add Mysa Response record';
        var defaultColumns = {};
        Object.keys(this.columnIdName).forEach(function (element) {
            defaultColumns[element] = [];
        });
        var item = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to add a new record to existing list?',
            title: tit,
            tree: result.tree,
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            content: defaultColumns,
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot, imts) {
                return iot.length > 0
                    ? (_a = []).concat.apply(_a, iot.map(function (el) { return imts[el]; }))
                    : '';
                var _a;
            },
            listCountries: function (tree, iot, imt, imts) {
                if (iot.length > 0 && imt.length > 0) {
                    var countries = [];
                    for (var _i = 0, iot_1 = iot; _i < iot_1.length; _i++) {
                        var el = iot_1[_i];
                        for (var _a = 0, imt_1 = imt; _a < imt_1.length; _a++) {
                            var elem = imt_1[_a];
                            if (tree[el][elem]) {
                                countries = countries.concat(tree[el][elem]);
                            }
                        }
                    }
                    return countries;
                }
                return tree[iot] ? tree[iot][imt] : DEFAULT_SELECTION;
            },
            yesNoArr: YES_NO_ARR,
            arrayNA: NA_ARR,
            respArr: RESP_ARR,
            cmrArr: CMR_ARR,
            drArr: DR_GOE_ARR,
            taArr: TA_ARR,
            cdArr: CD_ARR,
            solutionArr: YES_NO_ARR,
            mysaArr: MYSA_DUP,
            scArr: SC_DUP,
            ncArr: NC,
            solArr: SOLUTION_ARR,
            incArr: INCENTIVES_GOE_ARR,
            cdResp: CD_RESP,
            specBidResp: SPEC_BID_RESP,
            cvrSSAResp: CVR_SSA_RESP,
            incGoeResp: RESP_INC_GOE_ARR,
            codeResp: CODE_RESP,
            table: this.checkData.db
        };
        this.Dialog.updateValidForm(event, item, this.TEMPLATE_CONFIRM)
            .then(function (dResult) {
            if (!dResult.confirm) {
                return;
            }
            _this.Dialog.updateValidForm(event, item, 'mysaresponse-edit.html')
                .then(function (answer) {
                var content = answer.mdTextContent;
                var countryReslt = _this.extractCountry();
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: _this.getRecordsArr(content, countryReslt),
                        table: _this.checkData.db,
                        email: _this.env.user.email,
                        function: 'insertRecord',
                        scopeBack: _this.scopeCreateRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            });
        });
    };
    CheckResultsUpdateController.prototype.getRecordsArr = function (content, countryReslt) {
        var contentArr = [];
        if (content['GEO'].length > 0) {
            for (var _i = 0, _a = content['GEO']; _i < _a.length; _i++) {
                var iot = _a[_i];
                if (content['IMT'].length > 0) {
                    for (var _b = 0, _c = content['IMT']; _b < _c.length; _b++) {
                        var imt = _c[_b];
                        if (countryReslt.tree[iot][imt] && content['COUNTRY'].length === 0) {
                            var oneRecord = Object.assign({}, content);
                            oneRecord['GEO'] = iot;
                            oneRecord['IMT'] = imt;
                            oneRecord = this.prepareRecord(oneRecord);
                            contentArr.push(oneRecord);
                        }
                        else {
                            for (var _d = 0, _e = content['COUNTRY']; _d < _e.length; _d++) {
                                var country = _e[_d];
                                if (countryReslt.tree[iot][imt] && countryReslt.tree[iot][imt].indexOf(country) !== -1) {
                                    var oneRecord = Object.assign({}, content);
                                    oneRecord['GEO'] = iot;
                                    oneRecord['IMT'] = imt;
                                    oneRecord['COUNTRY'] = country;
                                    oneRecord = this.prepareRecord(oneRecord);
                                    contentArr.push(oneRecord);
                                }
                            }
                        }
                    }
                }
                else {
                    var oneRecord = Object.assign({}, content);
                    oneRecord['GEO'] = iot;
                    oneRecord = this.prepareRecord(oneRecord);
                    contentArr.push(oneRecord);
                }
            }
        }
        else {
            var oneRecord = Object.assign({}, content);
            oneRecord = this.prepareRecord(oneRecord);
            contentArr.push(oneRecord);
        }
        return contentArr;
    };
    CheckResultsUpdateController.prototype.prepareRecord = function (oneRecord) {
        for (var field in oneRecord) {
            if (oneRecord[field]) {
                oneRecord[field] = Array.isArray(oneRecord[field]) ? oneRecord[field].join('/') : oneRecord[field];
            }
            else {
                oneRecord[field] = '';
            }
        }
        return oneRecord;
    };
    CheckResultsUpdateController.prototype.buildAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/mysa-response-check',
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.itemsLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.table.dtInstance.DataTable;
                draw.sourceData = _this.checkData.db;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
                _this.itemsLoaded = true;
            },
            dataSrc: function (data) {
                _this.itemsLoaded = true;
                _this.tableItems = data.data;
                _this.processing = false;
                _this.countData = data.data.length;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Mysa Response data from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.itemsLoaded = true;
                _this.importingExcel = false;
                $('#table_processing').hide();
            }
        };
    };
    CheckResultsUpdateController.prototype.buildLogAjaxOption = function () {
        var _this = this;
        return {
            url: '/api/admin/mysa-response-log',
            type: 'POST',
            beforeSend: function (request) {
                _this.processing = true;
                _this.logLoaded = false;
                request.setRequestHeader('Authorization', "Bearer " + _this.env.user.token);
            },
            data: function (draw) {
                var dt = _this.tableLog.dtInstance.DataTable;
                draw.sourceData = _this.checkData.db;
                if (dt && dt.context && Array.isArray(dt.context)) {
                    draw.alphabetSearch = dt.context[0].alphabetSearch;
                }
            },
            dataSrc: function (data) {
                _this.logItems = data.data;
                _this.logLoaded = true;
                _this.processing = false;
                return data.data;
            }, error: function (xhr, errorMessage, thrown) {
                // Display message, when an error appears
                var items = {
                    icon: 'ERROR',
                    message: 'Unable to retrieve Compliance Plan log from the server for the following reason:<br><br> ',
                    title: 'Server Error'
                };
                if (xhr.responseText) {
                    items.message += "<b>" + xhr.responseText + "</b>\n                    <br>Please try again, if the problem persists contact the DMT System Administrators";
                }
                else {
                    if (errorMessage === 'timeout' || thrown.toLowerCase().indexOf('time-out') > -1) {
                        items.message += '<b>The server took too long to send the data and timed-out -&nbsp;</b><br>';
                    }
                    items.message += "<b style=\"color:red\">" + errorMessage + "/" + thrown + "</b><br><br>\n                    This is usually a temporary problem.\n                    &nbsp;Please try again, if the problem persists contact the DMT System Administrators";
                }
                _this.logLoaded = true;
                $('#table_processing').hide();
            }
        };
    };
    CheckResultsUpdateController.prototype.generateColumn = function (columnId, renderFn) {
        var columnName = this.columnIdName[columnId] || this.columnLogIdName[columnId];
        var orderable = true;
        return this.DTColumnBuilder
            .newColumn(columnId)
            .withOption('name', columnId)
            .withTitle(columnName ? columnName : columnId)
            .renderWith(renderFn ? renderFn : function (data) {
            return "<span class=\"columnTest\">" + data + "</span>";
        });
    };
    CheckResultsUpdateController.prototype.buildColumns = function (columnName) {
        var arr = [];
        for (var col in columnName) {
            arr.push(this.generateColumn(col));
        }
        if (columnName === this.columnIdName) {
            arr.push(this.generateColumn('Actions', this.actionButtons));
        }
        return arr;
    };
    CheckResultsUpdateController.prototype.actionButtons = function (data, type, full, meta) {
        return "\n        <md-button class=\"edit-button md-button md-ink-ripple md-2ink-ripple\" ng-click=\"vm.updateRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Edit\">\n                <md-icon class=\"black_icon\" md-svg-icon='edit_pen'></md-icon>\n        </md-button>\n        <md-button class=\"delete-button md-button md-ink-ripple\" ng-click=\"vm.deleteRow($event, '" + meta.row + "')\"\n            ng-disabled=\"vm.isSaving\" aria-label=\"Delete\">\n                <md-icon md-svg-icon='delete'></md-icon>\n        </md-button>";
    };
    /**
       * Function to update a row in DB
    */
    CheckResultsUpdateController.prototype.updateRow = function (event, rowId) {
        var _this = this;
        var result = this.extractCountry();
        var tit = 'Update Mysa Response record';
        var orgContent = {};
        Object.keys(this.columnIdName).forEach(function (element) {
            orgContent[element] = _this.tableItems[rowId][element];
        });
        var updatedData = {
            icon: 'QUESTION',
            message: 'Are you sure, you want to update a new record to existing list?',
            tree: result.tree,
            iots: Object.keys(result.tree).sort(),
            imts: result.imts,
            orgContent: orgContent,
            content: this.tableItems[rowId],
            cmrArr: CMR_ARR,
            listIOTs: function (tree) { return Object.keys(tree).sort(); },
            listIMTs: function (tree, iot, imt) {
                return Object.keys(tree[iot] || {}).sort();
            },
            listCountries: function (tree, iot, imt) {
                return tree[iot] ? tree[iot][imt] : DEFAULT_SELECTION;
            },
            yesNoArr: YES_NO_ARR,
            arrayNA: NA_ARR,
            respArr: RESP_ARR,
            taArr: TA_ARR,
            drArr: DR_GOE_ARR,
            cdArr: CD_ARR,
            solutionArr: YES_NO_ARR,
            mysaArr: MYSA_DUP,
            scArr: SC_DUP,
            ncArr: NC,
            solArr: SOLUTION_ARR,
            incGoeResp: RESP_INC_GOE_ARR,
            incArr: INCENTIVES_GOE_ARR,
            cdResp: CD_RESP,
            specBidResp: SPEC_BID_RESP,
            cvrSSAResp: CVR_SSA_RESP,
            codeResp: CODE_RESP,
            table: this.checkData.db
        };
        this.Dialog.updateValidForm(event, updatedData, this.TEMPLATE_CONFIRM)
            .then(function (dResult) {
            if (!dResult.confirm) {
                return;
            }
            _this.Dialog.updateValidForm(event, updatedData, 'mysaresponse-edit.html')
                .then(function (dResult) {
                dResult.mdTextContent.table = _this.checkData.db;
                var content = dResult.mdTextContent;
                for (var field in content) {
                    if (content[field]) {
                        content[field] = Array.isArray(content[field]) ? content[field].join('/') : content[field];
                    }
                    else {
                        content[field] = '';
                    }
                }
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        data: content,
                        originalData: dResult.orgContent,
                        table: _this.checkData.db,
                        email: _this.env.user.email,
                        function: 'updateRecord',
                        scopeBack: _this.scopeUpdateRecord,
                        script: _this.backendModuleName,
                        token: _this.env.user.token
                    }
                });
            });
        });
    };
    /**
     * Function to extract country
     */
    CheckResultsUpdateController.prototype.extractCountry = function () {
        var result = this.settings.country_list.filter(function (el) { return el.ic === 'Country'; }).reduce(function (r, country) {
            r.tree[country.imt] = r.tree[country.imt] || {};
            r.tree[country.imt][country.imt_name] = r.tree[country.imt][country.imt_name] || [];
            r.tree[country.imt][country.imt_name].push(country.country);
            r.tree[country.imt][country.imt_name].sort();
            r.imts[country.imt] = r.imts[country.imt] || [];
            r.imts[country.imt].push(country.imt_name);
            r.imts[country.imt] = _.uniq(r.imts[country.imt]);
            r.imts[country.imt].sort();
            return r;
        }, { tree: {}, imts: {} });
        return result;
    };
    /**
     * Function to handle all errors
     */
    CheckResultsUpdateController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    CheckResultsUpdateController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    // tslint:disable-next-line:typedef
    CheckResultsUpdateController.prototype.openActionMenu = function ($mdOpenMenu, event) {
        $mdOpenMenu(event);
    };
    CheckResultsUpdateController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        'Dialog',
        'notify',
        'DTOptionsBuilder',
        'DTColumnBuilder',
        'DTColumnDefBuilder'
    ];
    return CheckResultsUpdateController;
}());
var CheckResultsUpdateComponent = (function () {
    function CheckResultsUpdateComponent() {
        this.templateUrl = 'checkupdate.html';
        this.controllerAs = 'vm';
        this.bindings = bindCheck;
        this.controller = CheckResultsUpdateController;
    }
    return CheckResultsUpdateComponent;
}());
angular
    .module('application')
    .component('checkResultsUpdate', new CheckResultsUpdateComponent());

//# sourceMappingURL=check.results.update.component.js.map
